import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

/*
 * "Explore ↗" cyan link with a small up-right arrow (SPEC §7.1.1 / §7.1.3).
 * Internal paths use <Link>; hash/external use <a>.
 */
export default function ExploreLink({ href = '#', label = 'Explore', className = '', ariaLabel }) {
  const cls = `explore-link${className ? ` ${className}` : ''}`;
  const inner = (
    <>
      {label}
      <ArrowUpRight size={16} strokeWidth={2.5} />
    </>
  );
  const isHash = href.includes('#');
  const isExternal = /^https?:\/\//i.test(href);
  if (isHash || isExternal) {
    return (
      <a
        className={cls}
        href={href}
        aria-label={ariaLabel}
        target={isExternal ? '_blank' : undefined}
        rel={isExternal ? 'noopener noreferrer' : undefined}
      >
        {inner}
      </a>
    );
  }
  return (
    <Link className={cls} to={href} aria-label={ariaLabel}>
      {inner}
    </Link>
  );
}
